export class Menu {
  id: string;
  code: string;
  name: string;
  icon: string;
  description: string;
  redirectTo: string;
  children?: Array<Menu>;
  salesOrg: Array<String>;
  constructor() {
    this.id = '';
    this.code = '';
    this.name = '';
    this.icon = '';
    this.description = '';
    this.redirectTo = '';
    this.children = [];
    this.salesOrg = [];
  }
}